// extracted by mini-css-extract-plugin
export default {"nameContainer":"nameContainer-JQhiT","circles":"circles-xTjoy","nameBar":"nameBar-TMbFL"};